var actions = {
	next: "다음",
	confirm: "확인",
	"continue": "계속"
};
var errors = {
	unknown: "알 수 없는 오류가 발생했습니다",
	contactSupport: "오류가 발생했습니다. 지원팀에 문의하십시오.",
	tryAgain: "오류가 발생했습니다. 다시 시도하세요.",
	submit: "제출에 오류가 있습니다."
};
var brands = {
	apple: "Apple",
	facebook: "Facebook",
	google: "Google",
	paypal: "PayPal",
	picarto: "Picarto",
	tiktok: "TikTok",
	trovo: "Trovo",
	twitch: "Twitch",
	youtube: "YouTube",
	twitter: "X (Twitter)",
	linkedin: "LinkedIn",
	streamlabs: "Streamlabs",
	mevo: "Mevo",
	typestudio: "TypeStudio"
};
var loginButton = {
	loginWith: "{name} 로그인",
	signupWith: "{name} 가입"
};
var alreadyHaveAccount = {
	company: "이미 {company} 계정이 있으세요?",
	text: "이미 Streamlabs ID가 있으세요?",
	link: "로그인"
};
var noAccount = {
	text: "아직 계정이 없으세요?",
	link: "가입"
};
var validation = {
	email: {
		invalid: "유효한 이메일 주소를 입력하세요"
	},
	password: {
		required: "비밀번호가 필요합니다",
		min: "비밀번호는 8자 이상이어야 합니다",
		number: "비밀번호에는 반드시 숫자가 포함되어야 합니다",
		upper: "비밀번호에는 반드시 대문자가 포함되어야 합니다",
		special: "비밀번호에는 반드시 특수 문자가 포함되어야 합니다"
	},
	username: {
		invalid: "이름은 5자 이상이어야 합니다"
	},
	code: {
		minmax: "코드는 6~10자 사이여야 합니다"
	}
};
var poweredBy = "<company>Streamlabs</company> 제공";
var card = {
	"404": {
		title: "회사를 찾을 수 없습니다!",
		desc: "다시 시도하거나 지원팀에 문의하세요."
	},
	company: {
		logoAlt: "{company} 로고"
	}
};
var checkTfaForm = {
	tfaCodePlaceholder: "6자리 인증 코드/8자리 백업 코드",
	successText: "성공! 리디렉션 중...",
	remember: "이 장치를 30일 동안 기억"
};
var createTfa = {
	scan: {
		title: "2단계 인증 활성화",
		lead: "선호하는 인증 앱에서 아래의 코드를 클릭/복사 또는 스캔하세요. 코드를 안전하게 저장하려면 <app0 />, <app1 />, <app2 /> 등의 앱을 사용하는 것을 권장합니다.",
		copied: "복사 완료!",
		instructions: "또는 인증 앱에 수동으로 코드를 입력합니다.",
		copy: "코드 복사",
		proceed: "확인"
	},
	confirm: {
		title: "2단계 인증 확인",
		lead: "생성된 2단계 인증 코드를 아래에 제출하면 2단계 인증이 확인 및 활성화됩니다.",
		label: "2단계 인증 코드(6자리)",
		verify: "코드 확인",
		next: "성공! 다음 단계"
	},
	save: {
		title: "복구 코드 저장",
		lead: "2단계 인증을 이용하지 못하는 경우를 대비하여 복구 코드를 저장하세요. 이 모달을 닫은 후에는 이 코드를 다시 이용할 수 없습니다.",
		label: "복구 코드",
		download: "복구 코드 다운로드",
		copied: "코드 복사 완료!",
		finished: "완료"
	}
};
var emailLoginForm = {
	buttonText: "로그인",
	emailPlaceholder: "이메일",
	passwordPlaceholder: "비밀번호"
};
var emailSignupForm = {
	buttonText: "가입",
	emailPlaceholder: "이메일 설정",
	passwordPlaceholder: "비밀번호 설정",
	usernamePlaceholder: "내 이름",
	ageLabel: "생년월일",
	agePlaceholder: "MM/DD/YYYY",
	agreeText: "본인은 Streamlabs <terms>서비스 약관</terms> 및 <privacy>개인정보 보호정책</privacy>에 동의합니다.",
	agreeError: "Streamlabs 이용 약관에 동의해주세요."
};
var ageInput = {
	invalidDate: "유효한 생일을 입력하세요.",
	futureDate: "생년월일은 과거여야 합니다.",
	minDate: "{year} 이전 날짜는 허용되지 않습니다.",
	minAge_one: "Streamlabs를 사용하려면 {years}세 이상이어야 합니다.",
	minAge_two: "Streamlabs를 사용하려면 {years}세 이상이어야 합니다.",
	minAge_other: "Streamlabs를 사용하려면 {years}세 이상이어야 합니다."
};
var forgotPasswordForm = {
	emailPlaceholder: "이메일",
	back: "로그인으로 돌아가기",
	successText: "성공! 비밀번호 재설정 코드를 전송했습니다.",
	buttonText: "재설정 이메일 요청",
	create: {
		successText: "성공! 시작할 수 있도록 인증 코드를 전송했습니다!",
		buttonText: "인증 코드 요청"
	},
	errors: {
		notFound: "이 이메일 주소로 발견된 계정 없음"
	}
};
var forgotPasswordCard = {
	forgot: {
	},
	title: "비밀번호를 잊으셨나요?",
	lead: "비밀번호를 재설정해야 하는 경우, 아래에 이메일을 입력해주세요. 비밀번호를 재설정할 수 있는 이메일을 보내드리겠습니다.",
	resetTitle: "비밀번호 재설정",
	resetLead: "이메일로 코드가 전송되었습니다. 양식을 작성하여 비밀번호를 재설정하세요.",
	create: {
		title: "비밀번호 생성",
		lead: "Streamlabs ID 생성을 축하합니다! 한 단계만 더 진행하면 Streamlabs 전체에 로그인할 수 있습니다!",
		resetTitle: "비밀번호 선택",
		resetLead: "이메일로 코드가 전송되었습니다. 코드를 사용하여 양식을 작성하면 비밀번호가 설정됩니다."
	},
	successText: "성공! 리디렉션 중...",
	signInTitle: "이미 계정이 있으세요?",
	signInBtn: "로그인"
};
var checkTfaCard = {
	title: "2단계 인증 확인",
	lead: "계속하려면 2단계 인증 코드를 입력하십시오.",
	successText: "2단계 인증 확인 성공!",
	back: "돌아가기"
};
var verifyEmailCard = {
	title: "이메일 확인",
	lead: "이메일에서 Streamlabs 8자리 코드를 확인하고 아래에 입력합니다.",
	back: "돌아가기",
	successText: "이메일 확인 성공!"
};
var upgradeCard = {
	confirm: {
		title: "{company} 연결 확인",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"이제부터 제공하신 이메일 및 비밀번호를 사용하여 {company}에 로그인할 수 있습니다.",
			"ID를 사용하여 Streamlabs의 기타 모든 제품을 이용하고 다른 기존의 계정을 연결할 수 있습니다(있는 경우).",
			"{company} 계정은 이 변경의 영향을 받지 않습니다."
		],
		button: "확인",
		cancel: "취소",
		switchAccount: "계정 전환",
		success: "연결 중..."
	},
	confirmed: {
		title: "성공!",
		subtitle: "Streamlabs ID 계정이 생성되었으며 {company} 계정에 연결되었습니다.",
		text: "모든 Streamlabs 제품에 Streamlabs ID를 이용할 수 있습니다. 기존 계정이 있는 경우, 각 앱에서 해당 계정을 이 ID에 연결할 수 있습니다.",
		button: "닫기"
	},
	error: {
		user: "사용자 인증에 실패했습니다. 다시 로그인을 시도하거나 지원팀에 문의하세요."
	}
};
var confirmCard = {
	confirm: {
		title: "{company} 연결 확인",
		subtitle: "일치하는 이메일을 가진 계정을 발견했습니다. 이 계정과 Streamlabs ID를 통합하시겠습니까?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Streamlabs ID를 통해 제공하신 이메일 및 비밀번호를 사용하여 {company}에 로그인할 수 있습니다.",
			"ID를 사용하여 Streamlabs의 기타 모든 제품을 이용하고 다른 기존의 계정을 연결할 수 있습니다(있는 경우).",
			"기업 계정은 이 변경의 영향을 받지 않습니다."
		],
		button: "확인",
		cancel: "취소",
		switchAccount: "계정 전환",
		success: "연결 중..."
	},
	confirmed: {
		title: "성공!",
		subtitle: "Streamlabs ID 계정이 생성되었으며 {company} 계정에 연결되었습니다.",
		text: "모든 Streamlabs 제품에 Streamlabs ID를 이용할 수 있습니다. 기존 계정이 있는 경우, 각 앱에서 해당 계정을 이 ID에 연결할 수 있습니다.",
		button: "닫기"
	},
	error: {
		user: "사용자 인증에 실패했습니다. 다시 로그인을 시도하거나 지원팀에 문의하세요."
	}
};
var upgradeConfirmCard = {
	confirm: {
		title: " ID에 이미 연결된 {company} 계정이 있습니다",
		subtitle: "연결된 계정의 연결을 해제하고 현재 Streamlabs 계정에 연결하시겠습니까?",
		userLine: "<b>Streamlabs ID</b> {email}",
		items: [
			"Streamlabs ID를 통해 제공하신 이메일 및 비밀번호를 사용하여 Streamlabs에 로그인할 수 있습니다.",
			"ID를 사용하여 Streamlabs의 기타 모든 제품을 이용하고 다른 기존의 계정을 연결할 수 있습니다(있는 경우).",
			"Streamlabs 계정은 이 변경의 영향을 받지 않습니다."
		],
		button: "확인",
		cancel: "취소",
		switchAccount: "계정 전환",
		success: "연결 중...",
		agreeLabel: "연결을 함으로써 Streamlabs ID에 연결된 기존 {company} 계정에 대한 액세스를 상실한다는 것을 이해합니다."
	},
	confirmed: {
		title: "성공!",
		subtitle: "Streamlabs ID 계정이 생성되었으며 {company} 계정에 연결되었습니다.",
		text: "모든 Streamlabs 제품에 Streamlabs ID를 이용할 수 있습니다. 기존 계정이 있는 경우, 각 앱에서 해당 계정을 이 ID에 연결할 수 있습니다.",
		button: "닫기"
	},
	error: {
		user: "사용자 인증에 실패했습니다. 다시 로그인을 시도하거나 지원팀에 문의하세요."
	}
};
var loginCard = {
	title: "로그인",
	lead: "<company>{company}</company>에 <id>Streamlabs ID</id>로 로그인",
	accountExists: "<b>Streamlabs ID</b>가 있는 것 같습니다. 이메일로 로그인하십시오.",
	forgotPassword: "비밀번호를 잊으셨나요?",
	successText: "성공! 리디렉션 중...",
	signInTitle: "플랫폼으로 로그인"
};
var loginSourcesCard = {
	title: "로그인",
	lead: "이메일/비밀번호로 로그인",
	withSlId: "Streamlabs ID로 로그인",
	noAccountMessage: "이 로그인 방법과 연결된 계정이 보이지 않습니다. 다른 로그인 방법을 시도해보세요. 아직 가입하지 않은 경우 <signup>가입</signup>해주세요.",
	accountExistsMessage: "Twitch 이메일 주소가 이미 Streamlabs에 연결되어 있습니다. Streamlabs 이메일 및 비밀번호를 사용하여 로그인해주세요."
};
var resetPasswordForm = {
	emailPlaceholder: "이메일",
	codePlaceholder: "6~8자리 이메일 코드",
	tfaCodePlaceholder: "2단계 인증 코드",
	newPasswordPlaceholder: "새 비밀번호",
	tfaError: "재설정 코드는 6~10자 사이여야 합니다",
	next: "코드를 받으셨나요?",
	back: "비밀번호를 잊으셨나요?로 돌아가기",
	buttonText: "비밀번호 변경",
	successText: "비밀번호 재설정 완료",
	create: {
		back: "시작으로 돌아가기",
		buttonText: "비밀번호 설정",
		successText: "비밀번호 설정 성공"
	}
};
var changePasswordForm = {
	currentPasswordPlaceholder: "현재 비밀번호",
	newPasswordPlaceholder: "새 비밀번호",
	newPasswordConfirmationPlaceholder: "새 비밀번호 확인",
	buttonText: "비밀번호 변경",
	successText: "비밀번호 업데이트 성공",
	newPasswordConfirmationError: "새 비밀번호가 일치하지 않습니다",
	back: "대시보드로 돌아가기"
};
var changePasswordCard = {
	title: "비밀번호 변경",
	lead: "현재 비밀번호를 입력하고 아래에 새 비밀번호를 입력합니다.",
	successText: "비밀번호 업데이트 성공"
};
var removeTfaForm = {
	tfaCodePlaceholder: "6자리 인증 코드/8자리 백업 코드",
	successText: "2단계 인증 제거 완료",
	removeBtn: "확인 및 제거"
};
var removeTfaCard = {
	title: "2단계 인증 제거",
	lead: "아래에 2단계 인증 확인 코드를 입력하면 계정에서 2단계 인증이 제거됩니다.",
	successText: "2단계 인증 제거 완료",
	back: "대시보드로 돌아가기"
};
var verifyEmailForm = {
	codePlaceholder: "8자리 이메일 코드",
	tfaCodePlaceholder: "2단계 인증 코드",
	emailPlaceholder: "이메일 주소",
	buttonText: "이메일 확인",
	successText: "이메일 확인 성공",
	requestBtn: "새 코드 요청",
	requestingBtn: "요청 중...",
	requestSuccess: "코드가 이메일로 전송되었습니다",
	requestAgain: "{seconds}초 후 다시 요청",
	tfaError: "재설정 코드는 6~10자 사이여야 합니다",
	back: "돌아가기"
};
var signupCard = {
	title: "가입",
	lead: "<id>Streamlabs ID</id> 계정 생성하여 <company>{company}</company> 사용하기",
	successText: "성공! 리디렉션 중..."
};
var signupSourcesCard = {
	title: "가입",
	lead: "<id>Streamlabs ID</id> 계정 생성하여 <company>{company}</company> 사용하기",
	withSlId: "Streamlabs ID 생성"
};
var connectCard = {
	connect: {
		title: "계정을 선택하여",
		lead: "<b>{company}</b> 계속하기",
		authorize: "권한 부여",
		authorizeSuccess: "성공!",
		cancel: "취소",
		disclaimer: {
			streamlabs: "계속하면 <b>{company}</b>에 Streamlabs ID(내 이름, 이메일 주소, 언어 설정, 프로필 사진)가 공유됩니다. <b>{company}</b> 계정 인증 시 <b>{company}</b> <privacy>개인정보 보호정책</privacy> 및 <terms>이용 약관</terms>에 동의하게 됩니다.",
			"default": "계속하면 Streamlabs가 <b>{company}</b>에 내 이름, 이메일 주소, 언어 설정, 프로필 사진을 공유합니다. <b>{company}</b> 계정 인증 시 <b>{company}</b> <privacy>개인정보 보호정책</privacy> 및 <terms>이용 약관</terms>에 동의하게 됩니다."
		},
		emailRequired: "진행 전 이메일 인증 필요",
		tfaRequired: "진행 전 2단계 인증 필요"
	},
	login: {
		title: "{company}에 로그인",
		lead: "계정을 연결하려면 로그인 상태여야 합니다.",
		loginBtn: "로그인하려면 진행"
	},
	error: {
		title: "{company}에 로그인",
		lead: "현재는 요청을 인증할 수 없습니다.",
		verifyEmail: "이메일 확인",
		verify2fa: "2FA 확인"
	},
	"switch": {
		btn: "다른 계정 사용"
	}
};
var appsDropdown = {
	label: "Streamlabs 제품 및 앱",
	viewMore: "확장",
	viewLess: "축소"
};
var platformButtons = {
	loginWithPlatform: "플랫폼으로 로그인",
	signUpWithPlatform: "플랫폼으로 가입",
	signUpLead: "이것은 가입 옵션일 뿐이며 다양한 플랫폼에 대한 라이브 스트리밍을 지원합니다."
};
var ultraCheckoutCard = {
	title: "<b>Streamlabs Ultra</b>로 라이브 스트림, 브랜딩, 편집 등의 수준을 높여보세요.",
	badge: "<b>{planName}</b> 포함",
	totalValue: "{price, currency} 상당",
	price: {
		month: "{price, currency}/월",
		year: "{price, currency}/연"
	},
	description: {
		month: "<b>Streamlabs Desktop</b>, <b>콘솔</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> 등 전체 제품 모음의 프리미엄 기능을 하나의 합리적인 가격으로 이용할 수 있습니다.",
		year: "<b>Streamlabs Desktop</b>, <b>콘솔</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> 등 전체 제품 모음의 프리미엄 기능을 하나의 합리적인 가격으로 이용할 수 있습니다."
	},
	seeIncluded: "더 알아보기",
	buyNow: "업그레이드"
};
var ultraCheckoutBanner = {
	title: "<b>Streamlabs Ultra</b>로 라이브 스트림, 브랜딩, 편집 등의 수준을 높여보세요.",
	badge: "<b>{planName}</b> 포함",
	totalValue: "{price, currency} 상당",
	price: {
		month: "{price, currency}/월",
		year: "{price, currency}/연"
	},
	description: {
		month: "<b>Streamlabs Desktop</b>, <b>콘솔</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> 등 전체 제품 모음의 프리미엄 기능을 하나의 합리적인 가격으로 이용할 수 있습니다.<link />",
		year: "<b>Streamlabs Desktop</b>, <b>콘솔</b>, <b>Talk Studio</b>, <b>Podcast Editor</b>, <b>Cross Clip</b> 등 전체 제품 모음의 프리미엄 기능을 하나의 합리적인 가격으로 이용할 수 있습니다.<link />"
	},
	seeIncluded: "더 알아보기",
	buyNow: "업그레이드"
};
var connect = {
	waitMessage: "데이터 병합 중. 이 창을 닫지 마세요."
};
var verifyPasswordCard = {
	success: "비밀번호가 성공적으로 확인되었습니다.",
	title: "확인을 위해 다시 인증해 주세요.",
	lead: "기존 이메일과 비밀번호로 로그인하여 Streamlabs ID를 계속 업데이트하세요.",
	buttonText: "다음"
};
var emailChangeForm = {
	agreeError: "이 조치를 이해했는지 확인하시기 바랍니다.",
	buttonText: "다음",
	emailPlaceholder: "새 이메일 주소",
	agreeText: "본인은 인증이 완료되면 연결된 모든 Streamlabs 제품에서 Streamlabs ID가 변경된다는 것을 이해합니다."
};
var verifyNewEmailCard = {
	title: "Streamlabs ID 변경",
	lead: "Streamlabs ID로 사용할 새 이메일을 입력하세요. 이 주소로 6~8자리 인증 코드를 보내드립니다.",
	successText: "새 이메일 사용 가능"
};
var verifyNewEmailOwnershipCard = {
	title: "업데이트된 Streamlabs ID 확인",
	lead: "이메일에서 Streamlabs 8자리 코드를 확인하고 아래에 입력하세요.",
	buttonText: "확인",
	back: "뒤로",
	codePlaceholder: "8자리 이메일 코드",
	successText: "이메일 소유권 확인 성공"
};
var verifyTfaCard = {
	title: "2단계 인증 코드",
	lead: "인증 앱에서 6자리 인증 코드를 입력하세요.",
	codePlaceholder: "6자리 코드",
	buttonText: "확인",
	successText: "2단계 인증 확인",
	back: "뒤로"
};
var ageGateForm = {
	ageLabel: "생년월일",
	agePlaceholder: "MM/DD/YYYY"
};
var ageGateCard = {
	title: "계정 설정 완료",
	lead: {
		years: "계정을 만들려면 {years}세 이상이어야 합니다. <br />생년월일을 입력하면 설정이 완료됩니다.",
		noYears: "계정을 만들려면 생년월일을 입력해야 합니다. <br />입력하면 설정이 완료됩니다."
	},
	successText: "축하합니다! 계정 설정이 완료되었습니다."
};
var koKR = {
	actions: actions,
	errors: errors,
	brands: brands,
	loginButton: loginButton,
	alreadyHaveAccount: alreadyHaveAccount,
	noAccount: noAccount,
	validation: validation,
	poweredBy: poweredBy,
	card: card,
	checkTfaForm: checkTfaForm,
	createTfa: createTfa,
	emailLoginForm: emailLoginForm,
	emailSignupForm: emailSignupForm,
	ageInput: ageInput,
	forgotPasswordForm: forgotPasswordForm,
	forgotPasswordCard: forgotPasswordCard,
	checkTfaCard: checkTfaCard,
	verifyEmailCard: verifyEmailCard,
	upgradeCard: upgradeCard,
	confirmCard: confirmCard,
	upgradeConfirmCard: upgradeConfirmCard,
	loginCard: loginCard,
	loginSourcesCard: loginSourcesCard,
	resetPasswordForm: resetPasswordForm,
	changePasswordForm: changePasswordForm,
	changePasswordCard: changePasswordCard,
	removeTfaForm: removeTfaForm,
	removeTfaCard: removeTfaCard,
	verifyEmailForm: verifyEmailForm,
	signupCard: signupCard,
	signupSourcesCard: signupSourcesCard,
	connectCard: connectCard,
	appsDropdown: appsDropdown,
	platformButtons: platformButtons,
	ultraCheckoutCard: ultraCheckoutCard,
	ultraCheckoutBanner: ultraCheckoutBanner,
	connect: connect,
	verifyPasswordCard: verifyPasswordCard,
	emailChangeForm: emailChangeForm,
	verifyNewEmailCard: verifyNewEmailCard,
	verifyNewEmailOwnershipCard: verifyNewEmailOwnershipCard,
	verifyTfaCard: verifyTfaCard,
	ageGateForm: ageGateForm,
	ageGateCard: ageGateCard
};

export { koKR as k };
//# sourceMappingURL=ko-KR.es.js.map
